import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessGuard } from './auth/auth.guard';
import { NotFoundPageComponent } from './shared/components/not-found-page/not-found-page.component';
import { NOT_FOUND_SLUG, SERVIZI_SLUG } from './app.routes';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./page/guest/guest.module').then((m) => m.GuestModule),
    canActivate: [AccessGuard],
    runGuardsAndResolvers: 'always',
    data: { guest: true },
  },
  {
    path: SERVIZI_SLUG,
    loadChildren: () =>
      import('./page/logged/logged.module').then((m) => m.LoggedModule),
    canActivate: [AccessGuard],
    runGuardsAndResolvers: 'always',
    data: { guest: false },
  },
  {
    path: NOT_FOUND_SLUG,
    component: NotFoundPageComponent,
  },
  {
    path: '**',
    redirectTo: `/${NOT_FOUND_SLUG}`,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
